import React, { useState } from 'react'

export default function SeeMoreRoutePlanButton({ id, text, uuid, status }) {
  const [showMore, setShowMore] = useState(false)
  const handleButtonChange = (e, text) => {
    e.stopPropagation()
    if (text.length > 300 && (status == 'created' || status == 'disabled')) {
      window.location = `/plan_de_visitas/${uuid}`
    } else {
      setShowMore(!showMore)
    }
  }

  return (
    <div>
      {showMore && (
        <>
          <div key={id}>{`${text} `}</div>
          <a className="see-more-button-blue" onClick={(e) => setShowMore(false)}>
            Ver menos
          </a>
        </>
      )}
      {!showMore && (
        <>
          <span className="see-more-precut-text">{`${text.substring(0, 80)} `}</span>
          <a className="see-more-button-blue" onClick={(e) => handleButtonChange(e, text)}>
            Ver más...
          </a>
        </>
      )}
    </div>
  )
}
